"use client";

import { useBranding } from "./useBranding";

/**
 * Renders the tenant app name as a two-tone wordmark: the first half plain, the
 * second half wrapped in an accent span (className supplied by the caller so it
 * matches each site's existing teal class). For the default "Aksademia" this is
 * "Aksa" + <span>demia</span> — byte-identical to the hardcoded wordmarks it replaces.
 * Uses a fragment so it drops into existing markup without an extra wrapper element.
 */
export function BrandWordmark({ accentClassName }: { accentClassName?: string }) {
  const { appName } = useBranding();
  const chars = Array.from(appName);
  const splitAt = Math.floor(chars.length / 2);
  const head = chars.slice(0, splitAt).join("");
  const tail = chars.slice(splitAt).join("");
  return (
    <>
      {head}
      <span className={accentClassName}>{tail}</span>
    </>
  );
}
